export enum Role {
    User = "User",
    Employee = "Employee",
    Admin = "Admin",
}
